var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.86204 10.5002C4.60004 10.5002 4.33904 10.3982 4.14304 10.1952L0.28004 6.19525C-0.0979602 5.80225 -0.0929602 5.17925 0.29304 4.79325L4.29304 0.79325C4.68304 0.40225 5.31604 0.40225 5.70704 0.79325C6.09704 1.18425 6.09704 1.81625 5.70704 2.20725L2.40204 5.51225L5.58104 8.80525C5.96504 9.20325 5.95404 9.83625 5.55704 10.2192C5.36204 10.4072 5.11204 10.5002 4.86204 10.5002Z",
    fill: "#A0A5B0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigArrowIcon);
export default __webpack_public_path__ + "static/media/big-arrow-icon.86426c33573a881e3b09874254d1eb77.svg";
export { ForwardRef as ReactComponent };